import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class GeneralInterceptor implements HttpInterceptor {

  constructor(private authenticationService: AngularFireAuth) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return this.authenticationService.idToken
      .pipe(
        switchMap(token => {
          let copiedRequest = request.clone({
            setHeaders: {
              'Accept': `application/json`,
              'Content-Type': `application/json`
            }
          });

          if (token) {
            copiedRequest = request.clone({
              setHeaders: {
                'Accept': `application/json`,
                'Content-Type': `application/json`,
                'Authorization': 'Bearer ' + token
              }
            });
          }
          return next.handle(copiedRequest);
        })
      );
  }
}
